import React, { useState } from 'react';

import { saveReferralCode } from '../../utils/referralSignUp';

import ReferralCodeForm from './referral/ReferralCodeForm';
import ReferralSignUp from './referral/ReferralSignUp';

import styles from './ReferralSignUpForm.scss';

const ReferralSignUpForm = () => {
  const [submittedCode, setSubmittedCode] = useState('');

  const [isSecondStep, setSecondStep] = useState(false);
  const onCodeFormSubmit = (code) => {
    setSecondStep(true);
    setSubmittedCode(code);
  };
  const onSignUp = () => {
    saveReferralCode(submittedCode);
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.ladder} ${isSecondStep ? styles.secondStep : ''}`}>
        <ReferralCodeForm handleSubmit={onCodeFormSubmit} disabled={isSecondStep} />
        <ReferralSignUp disabled={!isSecondStep} onSignUp={onSignUp} />
      </div>
    </div>
  );
};

export default ReferralSignUpForm;
